// extracted by mini-css-extract-plugin
module.exports = {"error":"connection_error-module__error--Sr7ua"};